import {
	InputRow,
	TextInput,
	ValidationError
} from "client/Components";
import { IInputAttachable } from "client/Forms/attachable";
import { ReactElement } from "react";
import styles from "./TextInputWithExtension.module.less";

export type TextInputWithExtensionProps = {
	attachable: IInputAttachable<string | null>;
	fileExtension: string;
	placeholder?: string;
	isMobile: boolean;
};

export const TextInputWithExtension = (props: TextInputWithExtensionProps): ReactElement => {
	const {
		attachable,
		fileExtension,
		placeholder,
		isMobile
	} = props;

	return (
		<>
			<InputRow>
				<InputRow.Stretch>
					<TextInput
						{...attachable.attachToTextInput()}
						placeholder={placeholder}
						autoFocus={!isMobile ? "select" : undefined}
					/>
				</InputRow.Stretch>
				{Boolean(fileExtension) && (
					<p className={styles.extensionContainer}>{fileExtension}</p>
				)}
			</InputRow>
			<ValidationError
				{...attachable.attachToValidationError()}
			/>
		</>
	);
};

TextInputWithExtension.displayName="TextInputWithExtension";